import axios from 'axios';
import { Environment } from '@/shared/lib/environment';
import { registerInterceptors } from './interceptors';

const apiInstances = {
  gatewayApiInstance: axios.create({
    baseURL: import.meta.env.VITE_GATEWAY_API_URL,
  }),
  posApiInstance: axios.create(),
  collectionApiInstance: axios.create(),
  sdpApiInstance: axios.create(),
};

export const {
  gatewayApiInstance,
  posApiInstance,
  collectionApiInstance,
  sdpApiInstance,
} = apiInstances;

export const updateGlobalAPIBaseURLs = (environment: Environment) => {
  sdpApiInstance.defaults.baseURL = environment['sdp'];
  collectionApiInstance.defaults.baseURL = environment['sib-data-collection'];
  posApiInstance.defaults.baseURL = environment['rms-mapper'] + '/pos';
};

registerInterceptors(apiInstances);
